module.exports = __webpack_public_path__ + "static/img/magazine.eeda413.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/magazine.jpg
// module id = 296
// module chunks = 0